import React from 'react';
import './Version.css';
var Version = function (_a) {
    var showTag = _a.showTag, version = _a.version, env = _a.env, fullVersion = _a.fullVersion;
    localStorage.setItem('version', fullVersion);
    return (React.createElement(React.Fragment, null, showTag ? (React.createElement("section", { className: "version" },
        React.createElement("span", { "data-testid": "version" },
            version,
            " ",
            env))) : null));
};
export default Version;
